class PopUpDC {
  public COOKIE_VALUE = "never-show-up";
}

export default new PopUpDC();
